import { PenTool, Server, Wrench, RefreshCw, Settings2, AtSign, ShieldCheck, Gauge, ArrowUpRight } from "lucide-react";
import { SERVICES, whatsappLink } from "../content/site";
import { Reveal, SectionHeading } from "./Reveal";

const icons = {
  design: PenTool, hosting: Server, maintenance: Wrench, redesign: RefreshCw,
  management: Settings2, domain: AtSign, security: ShieldCheck, performance: Gauge,
};

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-24 lg:py-32 bg-[#FAFAFA]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading
          overline="What we do"
          title="Everything your website needs. One team."
          sub="From the first sketch to hosting, security and ongoing updates — WebStudios takes care of your website from start to finish, explained in plain English."
        />
      </Reveal>
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => {
          const Icon = icons[s.id];
          return (
            <Reveal key={s.id} delay={0.05 * (i % 3)} className={s.span || ""}>
              <article
                data-testid={`service-card-${s.id}`}
                className="group h-full bg-white border border-slate-200 rounded-2xl p-8 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-[#0055FF]/40 hover:shadow-[0_16px_48px_rgba(2,6,23,0.08)] flex flex-col"
              >
                <div className="flex items-start justify-between mb-5">
                  <span className="w-11 h-11 rounded-xl bg-[#F0F4FF] border border-[#0055FF]/15 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                    <Icon className="w-5 h-5 text-[#0055FF]" />
                  </span>
                  <span className="font-mono2 text-xs font-semibold text-[#0055FF] bg-[#F0F4FF] border border-[#0055FF]/15 rounded-full px-3 py-1">{s.price}</span>
                </div>
                <h3 className="font-display text-xl font-semibold text-slate-900 tracking-tight">{s.title}</h3>
                <p className="mt-2.5 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {s.features.map((f) => (
                    <span key={f} className="text-[11px] text-slate-600 bg-slate-50 border border-slate-200 rounded-full px-2.5 py-1">{f}</span>
                  ))}
                </div>
                {s.note && <p className="mt-4 text-xs text-slate-400 italic">{s.note}</p>}
                <a href="#contact" data-testid={`service-cta-${s.id}`}
                  className="mt-auto pt-5 inline-flex items-center gap-1 text-sm font-medium text-[#0055FF] hover:text-cyan-600 transition-colors duration-200">
                  Enquire about this <ArrowUpRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </article>
            </Reveal>
          );
        })}
      </div>
      <Reveal delay={0.1} className="mt-12 text-center">
        <p className="text-slate-600 text-sm">
          Need something more specific?{" "}
          <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" data-testid="services-custom-quote-link" className="text-[#0055FF] font-medium hover:underline">
            Get in touch for a custom quote.
          </a>
        </p>
      </Reveal>
    </div>
  </section>
);
